import {
  chakraUseBreakpointValue as useBreakpointValue,
} from "@airhelp/react-ui-components";
import type { OurFeesCompensationTableAdapterProps } from "modules/storyblok/adapters/OurFeesCompensationTable/OurFeesCompensationTable.d";
import type { ReactStoryblokComponent } from "modules/storyblok/types";
import OurFeesCompensationTableDesktop from "./OurFeesCompensationTableDesktop";
import OurFeesCompensationTableMobile from "./OurFeesCompensationTableMobile";

const OurFeesCompensationTable = ({ blok }: ReactStoryblokComponent<OurFeesCompensationTableAdapterProps>) =>
  useBreakpointValue({ md: true }) ? <OurFeesCompensationTableDesktop blok={blok} /> : <OurFeesCompensationTableMobile blok={blok} />;

export default OurFeesCompensationTable;
